import * as React from 'react';
import { List } from '@grandvisionhq/common';
import { Heading, Hr } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import BenefitsList from '../../components/BenefitsList/BenefitsList.js';

/*
 * This is hardcoded content for VisionExpress UK and IE.
 * In the future, this content should come from Bloomreach instead.
 */ const hardCodedUspList = [
    'Free solutions for monthly lenses',
    'Manage your subscription online',
    'Free trials of the latest products',
    'Free replacement lenses', 
];
const hardCodedBenefitsList = [
    {
        iconName: 'eye-test',
        title: 'Free annual eye test',
        subtitle: 'Including free retinal photography'
    },
    {
        iconName: 'discount-bubble',
        title: '50% off',
        subtitle: 'Glasses and prescription and non-prescription sunglasses'
    },
    {
        iconName: 'truck',
        title: 'Free home delivery',
        subtitle: `Never be left out of your lenses, we'll deliver them to your door`
    },
    {
        iconName: 'business',
        title: 'Free service',
        subtitle: 'Free expert aftercare service'
    }, 
];
const NoSubscriptions = ()=>{
    const { getLabel , getFormattedLabel , hasLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "no-subscriptions"
    }, hasLabel('account.noSubscriptions.help') && /*#__PURE__*/ React.createElement("p", {
        className: "no-subscriptions__help"
    }, getFormattedLabel('account.noSubscriptions.help', {
        parseHTML: true
    })), /*#__PURE__*/ React.createElement("p", {
        className: "no-subscriptions__description"
    }, getLabel('account.noSubscriptions.description')), /*#__PURE__*/ React.createElement("section", null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, getLabel('account.noSubscriptions.benefits.title')), /*#__PURE__*/ React.createElement(BenefitsList, {
        className: "no-subscriptions__benefits-list",
        items: hardCodedBenefitsList
    })), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement("section", null, /*#__PURE__*/ React.createElement(List, {
        className: "no-subscriptions__checkmark-list",
        icon: "checkmark",
        items: hardCodedUspList
    })));
};
var NoSubscriptions$1 = NoSubscriptions;

export { NoSubscriptions$1 as default };
//# sourceMappingURL=NoSubscriptions.js.map
